import React from "react";
import UsersCommon from "../UsersMain";
import { useParams } from "react-router-dom";

const RecentUsers = () => {
  const type = "Recent_Signups";
  const title = "Recent Signups";

  let { page } = useParams();

  console.log('page', page);

  return <UsersCommon type={type} title={title} />;
};

export default RecentUsers;

